import component from './component.vue'
export default component


// WEBPACK FOOTER //
// ./src/components/parts/scrolltop/index.js